import React from "react";
import ReactDOM from "react-dom/client"; // ✅ Use React 18 method
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root")); // ✅ React 18 way
root.render(
    <App />
);
